import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaFinFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA VENCIMIENTO' htmlFor='input-fechaFin' md={12} />
      <Col md={12}>
        <Field name='fechaFin'>
          {({ field }) => (
            <Form.InputDate {...field} id='input-fechaFin' disabled={fIsSubmitting} isInvalid={iTouched && iError} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFinFormGroup)
